import { Component, ElementRef } from '@angular/core';
import { NavController, NavParams, ViewController, ModalController, AlertController, ToastController, ActionSheetController } from 'ionic-angular';
import { AbstractPage } from '../../_com/abstract-page';
import { ReserveListPage } from '../list/reserve-list';
import { ReserveAction } from '../../../actions/reserve.action';
import { FamilyListPage } from '../../family/list/family-list';

/**
 * Generated class for the ReserveEditPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@Component({
  selector: 'page-reserve-edit',
  templateUrl: 'reserve-edit.html',
})
export class ReserveEditPage extends AbstractPage{

  isNewer = true;
  isFamily2Exists = false;
  // pickup_time: any;
  name_others: String;
  tel_others: String;
  relation_other: String;
  // 複数日付選択
  multiDate: any;

  data = {
    id:"",
    datetime:{
      input:{
        date : new Date(),
        time : null,
      },
    },
    // お迎え情報は、予約編集登録画面では表示しない
    // pickup: {},
    family:{},
    children:[{}],
    memo: "",
    type: "",
    status: null,
    bathRequest: null,
  };

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public modalController:ModalController,
    public viewController:ViewController,
    public alertController:AlertController,
    public toastController:ToastController,
    private reserveAction:ReserveAction,
    public actionSheetController: ActionSheetController,
    private el: ElementRef,
    ) {
    super();

    //初期情報設定
    this.multiDate = this.reserveAction.getInitialReserveMulthDate();

    //初期日付指定
    this.data.datetime.input.time = this.reserveAction.getInitialReserveTime();
    // お迎え時間初期表示
    // this.pickup_time = this.data.datetime.input.time[1];
    // 緊急のお迎えまでに要する時間
    // this.data.pickup['elapsed_time'] = "1";
    //編集データ設定
    if(this.navParams.get("id")){
      this.isNewer = false;
      this.data.id = this.navParams.get("id");
    }

    if(this.navParams.get("family")){
      this.isNewer = false;
      this.refrectFamily(this.navParams.get("family"));
    }

    if(this.navParams.get("date")){
      // 単独での設定
      this.data.datetime.input.date = this.navParams.get("date");
      // 複数日付設定
      this.multiDate = [this.navParams.get("date")];
    }

    if(this.navParams.get("time")){
      this.data.datetime.input.time = this.navParams.get("time");
    }

    if (this.navParams.get("bathRequest")){
      this.data.bathRequest = this.navParams.get("bathRequest");
    }

    if (this.navParams.get("status")) {
      this.data.status = this.navParams.get("status");
    }
    // // お迎え情報が登録されている場合、取得する
    // if (this.navParams.get("pickup")) {
    //   this.data.pickup = this.navParams.get("pickup");
    //   this.pickup_time = new Date(this.data.pickup['pickup_time']);
    // }
    this.refreshChildrenTimeData();

    //DOMアクセス準備
    super.readyDomAccess(this.el);
  }

  /**
   * 子供用の時間データフォーマット
   */
  refreshChildrenTimeData(){
    for (let index in this.data.children) {
      this.refleshTimeData(this.data.children[index]);
    }
  }

  /**
   * 新規顧客
   */
  goNewCustomer(){
    this.isNewer = false;
  }

  /**
   * 再来顧客
   */
  goSecondComingCustomer(){
    this.isNewer = false;
    this.openFamilyChooser();
  }

  /**
   * 子供詳細情報画面を開く
   */
  goChildDetail(child){
    child["showDetail"] = true;
  }

  /**
   * 子供詳細情報画面を閉じる
   */
  popChildDetail(child){
    child["showDetail"] = false;
  }

  /**
   * 更新処理
   */
  save(){

    //必須チェック
    if(this.hasInvalidRequired()){
      this.alert(this.alertController, "未入力の項目を確認してください");
      return;
    }

    if (this.multiDate.length === 0) {
      this.alert(this.alertController, "予約日時を選択してください");
      return;
    }


    let actionSheet = this.actionSheetController.create({
      title: '予約処理',
      buttons: [
        {
          text: '今すぐ予約を完了する',
          handler: () =>  {
            this.data["status"] = 0;
            // this.reserveAction.save(this.data).subscribe((data) => {

            //   if (data["message"]) {
            //     this.alert(this.alertController, data["message"]);
            //     return;
            //   }

            //   this.toast(this.toastController, "予約が完了しました");
            //   this.viewController.dismiss({ id: data.data.Reserve.id });
            // });
            const func = async (data) => {
              // 複数の予約日時の数だけ送信する
              let reserveId;
              for (const date of this.multiDate) {
                data.datetime.input.date = date;
                const result = await this.reserveAction.save(data).toPromise();
                if (result && result["message"]) {
                  this.alert(this.alertController, result["message"]);
                  return;
                }
                reserveId = result.data.Reserve.id;
              }
              this.toast(this.toastController, "予約が完了しました");
              this.viewController.dismiss({ id: reserveId });
            };
            func(this.data);
          }
        },
        {
          text: '保留予約',
          handler: async () => {
            this.data["status"] = 4;
            // this.reserveAction.save(this.data).subscribe((data) => {

            //   if (data["message"]) {
            //     this.alert(this.alertController, data["message"]);
            //     return;
            //   }

            //   this.toast(this.toastController, "保留で予約しました");
            //   this.viewController.dismiss({ id: data.data.Reserve.id });
            // });
            // 複数の予約日時の数だけ送信する
            console.log(this.multiDate);
            const func = async (data) => {
              // 複数の予約日時の数だけ送信する
              let reserveId;
              for (const date of this.multiDate) {
                data.datetime.input.date = date;
                const result = await this.reserveAction.save(data).toPromise();
                if (result && result["message"]) {
                  this.alert(this.alertController, result["message"]);
                  return;
                }
                reserveId = result.data.Reserve.id;
              }
              this.toast(this.toastController, "保留で予約しました");
              this.viewController.dismiss({ id: reserveId });
            };
            func(this.data);
          }
        },
        {
          text: 'キャンセル',
          role: 'cancel',
          handler: () => {
          }
        }
      ]
    });
    actionSheet.present();


    //登録
    // this.confirm(this.alertController, "入力内容で登録します。よろしいですか？", ()=>{
    //   this.reserveAction.save(this.data).subscribe((data)=>{
    //     this.toast(this.toastController, "登録が完了しました");
    //     this.viewController.dismiss({id:data.data.Reserve.id});
    //   });
    // });
  }

    // その他の連絡先が選ばれた場合のみチェックする
    checkData (othersInfo) {
      let isError = false;
      if (othersInfo.name === "") {
        this.alert(this.alertController, "お名前を入力してください");
        isError = true;
        return isError;
      }
      if (othersInfo.tel === "") {
        this.alert(this.alertController, "お電話番号を入力してください");
        isError = true;
        return isError;
      }
      if (!othersInfo.tel.match(/^(0[5-9]0[0-9]{8}|0[1-9][1-9][0-9]{7})$/)) {
        this.alert(this.alertController, "正しい携帯電話番号を入力してください");
        isError = true;
        return isError;
      }
      if (othersInfo.relation === "") {
        this.alert(this.alertController, "続柄を入力してください");
        isError = true;
        return isError;
      }
      return isError;
    }


  /**
   * キャンセル処理
   */
  cancel(){

    //入力項目タッチ無し
    if(!this.hasTouched()){
      this.viewController.dismiss();
      return;
    }

    //入力項目タッチありで、画面を閉じる
    this.confirm(this.alertController, "画面を閉じます。よろしいですか？", ()=>{
      this.viewController.dismiss();
    });
  }

  /**
   * 予約リスト表示
   */
  viewReserveList(){
    let modal = this.modalController.create(ReserveListPage, {modal:true}, {enableBackdropDismiss:false});
    modal.present();
  }

  /**
   * 子供の入力内容をクリアする
   */
  clearChild(index){

    // this.confirm(this.alertController, (index + 1) + "人目のお子様を予約から外します。よろしいですか？", ()=>{
    this.confirm(this.alertController, (index + 1) + "人目に記載された「" + this.data.children[index]["kana"] + "」さんを予約から外します。よろしいですか？", ()=>{
      this.data.children.splice(index, 1);
      if(this.data.children.length == 0){
        this.data.children = [{}];
      }
    });
  }

  /**
   * 保護者チューザー起動
   */
  openFamilyChooser(){

    let modal = this.modalController.create(FamilyListPage, {modal:true}, {enableBackdropDismiss:false});
    modal.present();

    modal.onDidDismiss((d)=>{
      if(!d)return;
      this.refrectFamily(d.Family);
    });
  }

  /**
   * 家族情報を画面へ反映する
   */
  refrectFamily(family){

    this.data.family = family;

    if(this.navParams.get("type")){
      //前画面からの引き継ぎの場合、パラメータのお客様区分を設定
      this.data["type"] = this.navParams.get("type");
    } else {
      //ご家族選択からの新規申し込みの場合は、利用者データのお客様区分を設定
      this.data["type"] = family["type"];
    }

    if (this.data.family['tel2']) {
      this.isFamily2Exists = true;
    }

    this.data.children = [];
    for(let index in family.children){
      const child = family.children[index]["Child"];
      child["birthday"] = new Date(child["birthday"]);
      // 旧データの 99 は あじ が未確認のため、個別の食材へ展開して表示する
      child["tabetakotoaru_foods"] = this.expandLegacyTabetakotoaruFoods(child["tabetakotoaru_foods"]);
      this.data.children.push(child);
    }

    this.refreshChildrenTimeData();
  }

  /**
   * 子供入力枠を増やす
   */
  addChild(){
    this.data.children.push({});
  }

  /**
   * 「食べたことがある食材」の選択値を正規化する
   *
   * 99: 全て食べたことがある が選択されている場合は、全て食べたことにする
   * ただし あじ が選択された場合は 99 を解除して個別の食材へ展開する
   */
  onChangeTabetakotoaruFoods(child){
    child["tabetakotoaru_foods"] = this.normalizeTabetakotoaruFoods(child["tabetakotoaru_foods"]);
  }

  /**
   * 住所更新のinputイベント発火
   */
  eventFireForAddressInput(){
    var Event = document.createEvent('HTMLEvents');
    Event.initEvent('input', true, false );
    document.getElementsByName('address')[0].dispatchEvent(Event);
  }


}



// WEBPACK FOOTER //
// ./src/pages/reserve/edit/reserve-edit.ts